import "./Packages.module.css";
import Header from "@/reusable_sections/Header";
import TheGrowthTiers from "./sections/TheGrowthTiers";
import PackageComparisonGrid from "./sections/PackageComparisonGrid";
import FeatureShowcase from "./sections/FeatureShowcase";
import Footer from "@/reusable_sections/Footer";
export default function PackagesPage() {
  return <div>
      <Header />
      <TheGrowthTiers />
      <PackageComparisonGrid />
      <FeatureShowcase />
      <Footer />
    </div>;
}